//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AppMain',
  data: function data() {
    return {
      links: [{
        title: '官网',
        key: '1',
        href: 'https://www.baidu.com',
        blankTarget: true
      }, {
        title: '社区',
        key: '2',
        href: 'https://www.baidu.com',
        blankTarget: true
      }, {
        title: '文档',
        key: '3',
        href: 'https://www.baidu.com',
        blankTarget: true
      }],
      copyright: 'Copyright © 2024 河南鑫都实业有限公司版权所有  豫ICP备2025105689号-1'
    };
  },
  computed: {
    cachedViews: function cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key: function key() {
      return this.$route.path;
    }
  }
};